import {Component, Prop, Vue} from "vue-property-decorator";
import {UserModule} from "@/store/modules/user";
import {Loading} from "element-ui";
import {updMessageReviewUserByMessageReviewId} from "@/api/message";
import {delNullProperty} from "@/utils";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components: {
        MoreUsersFilter
    }
})
export default class TransferCommon extends Vue {
    @Prop() visible: false
    @Prop() id: ''

    disBtn = false
    userId = '' // 转交人Id
    opinion = '' // 转交理由


    created() {
        // console.log('this.id', this.id)
    }

    // computed
    get userList() {
        return UserModule.userList
    }

    /*
    * methods*/
    closeTransferTxtDialog() {
        this.$emit('handleClose', false)
    }

    confirmTransferTxtDialog() {
        if (!this.userId) {
            this.$message.error('请选择转交人')
            return
        }
        this.disBtn = true;
        this.$emit('doConfirm', false)
        const obj = {
            messageReviewId: Number(this.id),
            opinion: this.opinion,
            userId: this.userId,
        }
        const loading = this.$loading({
            lock: true,
            text: '审批转交中，请稍后',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.7)'
        });
        updMessageReviewUserByMessageReviewId(delNullProperty(obj)).then(() => {
            this.$message.success('审批转交成功')
            this.opinion = ''
            this.userId = ''
            setTimeout(() => {
                loading.close();
                window.close()
            }, 1500)
        }).catch(() => {
            this.disBtn = false;
            setTimeout(() => {
                loading.close();
            }, 500);
        })
    }

    changeUsers(e) {
        this.userId = e.id
    }
}
